import { useEffect } from 'react'

import { useBookingContext } from '@providers/booking'
import { useSessionContext } from '@providers/session'
import { matchPath, useParams } from 'react-router-dom'
import { useRoutes } from './use_routes'
import { TRouteConfig } from './types'

export const useAppRedirect = (routeConfigs: TRouteConfig[]) => {
  const ctx = useSessionContext()
  const bookingCtx = useBookingContext()
  const { accountName: locationName = '' } = useParams()
  const { navigateRoute } = useRoutes()
  const params = useParams()

  // Use matchPath to find the route config of current route
  const routeConfig = routeConfigs.find((route) => {
    const match = matchPath(route.path ?? '', location.pathname)
    return match && Object.keys(params).every((q) => q === '*' || params[q] === match.params[q])
  })

  useEffect(() => {
    // if the application is initializing, meaning the user is loading the app
    // in the browser or reloading the page
    if (ctx.state.status === 'INITIALIZING') {
      // if the user is authenticated we are good, lets move to AUTHENTICATED
      // status and move on
      if (ctx.state.user?.token) {
        ctx.dispatch({ type: 'AUTHENTICATED' })

        return
      } else if (routeConfig?.section === 'profile') {
        setTimeout(
          () =>
            navigateRoute(
              'signIn',
              {},
              {
                state: {
                  redirect: {
                    route: routeConfig.uid,
                    params,
                  },
                },
              }
            ),
          0
        )

        return
      } else {
        ctx.dispatch({ type: 'READY' })

        return
      }
    }

    // if the user is authenticated, check if the current location is available
    // with their LUPids, if not, log them out.
    // if is available, check if match the current location, if not, redirect
    if (ctx.state.status === 'AUTHENTICATED') {
      const userLUPs = ctx.state.userLUPs
      const userLocation = userLUPs.find((lup) => lup.locationName === locationName)

      // if the current logged in user does not have access to the location
      // they are trying to access, log them out and redirect them to home page
      if (!userLocation) {
        bookingCtx.dispatch({ type: 'RESET_STATE_FULL' })
        ctx.dispatch({ type: 'SIGNOUT' })
        ctx.dispatch({ type: 'READY' })
        navigateRoute('locationHome', { locationName })
        return
      }

      // if the user has access to the location, but the location is not the
      // current location, update the session data
      if (userLocation.lupId !== ctx.state.user?.lupId) {
        ctx.dispatch({ type: 'CHANGE_LOCATION', payload: { locationName, lupId: userLocation.lupId } })
      }

      ctx.dispatch({ type: 'READY' })
    }

    if (ctx.state.status === 'DEAUTHENTICATED') {
      ctx.dispatch({ type: 'READY' })
      setTimeout(() => navigateRoute('locationHome', { locationName }), 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationName, ctx.state.status, navigateRoute])
}
